import * as React from 'react';
import { EGDSLink } from '@egds/react-core/link';
import { EGDSText } from '@egds/react-core/text';
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from '@egds/react-core/layout-flex';
import { EGDSSpacing } from '@egds/react-core/spacing';
export function HeaderText(_a) {
  var _b;
  var headerText = _a.headerText,
    headerItems = _a.headerItems;
  var hasHeaderItems = !!(headerItems === null || headerItems === void 0 ? void 0 : headerItems.sectionData[0]);
  var textSize = hasHeaderItems ? 200 : 300;
  var linkSize = hasHeaderItems ? 'small' : 'medium';
  if (!headerText && !headerItems) {
    return null;
  }
  return React.createElement(EGDSLayoutFlex, {
    wrap: "wrap",
    justifyContent: "center",
    className: "loyalty_text"
  }, (_b = headerText === null || headerText === void 0 ? void 0 : headerText.sectionData) === null || _b === void 0 ? void 0 : _b.map(function (item, index) {
    return React.createElement(EGDSLayoutFlexItem, {
      key: (item === null || item === void 0 ? void 0 : item.id) || index
    }, React.createElement(EGDSText, {
      align: "center",
      size: textSize
    }, item === null || item === void 0 ? void 0 : item.text));
  }), hasHeaderItems && headerItems.sectionData.map(function (item, idx) {
    if (!(item === null || item === void 0 ? void 0 : item.text)) {
      return null;
    }
    if ((item === null || item === void 0 ? void 0 : item.type) === 'link') {
      return React.createElement(EGDSLayoutFlexItem, {
        key: (item === null || item === void 0 ? void 0 : item.id) || idx
      }, React.createElement(EGDSSpacing, {
        padding: {
          inlinestart: 'one'
        }
      }, React.createElement(EGDSLink, {
        inline: true,
        size: linkSize
      }, React.createElement("a", {
        href: item === null || item === void 0 ? void 0 : item.url,
        target: (item === null || item === void 0 ? void 0 : item.newWindow) ? '_blank' : '_self',
        rel: "noreferrer"
      }, item === null || item === void 0 ? void 0 : item.text))));
    }
    if ((item === null || item === void 0 ? void 0 : item.type) === 'text') {
      return React.createElement(EGDSLayoutFlexItem, {
        key: (item === null || item === void 0 ? void 0 : item.id) || idx
      }, React.createElement(EGDSText, {
        align: "center",
        size: textSize
      }, item === null || item === void 0 ? void 0 : item.text));
    }
    return null;
  }));
}